import { noticeFailure } from "@self/notices";

export function implementSearchBar() {
	const searchButton = document.getElementById("search-button");
	const searchButtonMobile = document.getElementById("search-button-mobile");
	const closeButton = document.getElementById("close-search-button");

	closeButton?.addEventListener("click", function () {
		const searchBar = document.getElementById("search-bar");
		const header = document.getElementById("header");
		const isFrontPage = header?.getAttribute("data-is-front-page") === "true";


		if (searchBar) {
			searchBar.style.visibility = "hidden"
			searchBar.style.opacity = "0";

			if (isFrontPage) {
				header.classList.add("header-fornt-page");
			}
		}

		const overlay = document.getElementById("overlay");

		if (overlay) {
			overlay.classList.add("gct-overlay-hidden");
		}
	});

	if (searchButton) {
		searchButton.addEventListener("click", function () {
			const searchBar = document.getElementById("search-bar");
			const header = document.getElementById("header");
			const isFrontPage = header?.getAttribute("data-is-front-page") === "true";

			if (searchBar) {

				if (searchBar.style.visibility === "visible") {
					searchBar.style.visibility = "hidden"
					searchBar.style.opacity = "0";

					if (isFrontPage) {
						header.classList.add("header-fornt-page");
					}
				} else {
					searchBar.style.visibility = "visible"
					searchBar.style.opacity = "1";

					if (isFrontPage) {
						header.classList.remove("header-fornt-page");
					}
				}
			}

			const overlay = document.getElementById("overlay");

			if (overlay) {
				if (searchBar?.style.visibility === "visible") {
					overlay.classList.remove("gct-overlay-hidden")
				} else {
					overlay.classList.add("gct-overlay-hidden");
				}
			}

		});
	}

	if (searchButtonMobile) {
		searchButtonMobile.addEventListener("click", () => {
			const mobileHeader = document.getElementById("mobile-header");
			const searchContent = document.getElementById("search-content");
			if (searchContent && mobileHeader) {
				mobileHeader.classList.add("gct-d-none");
				searchContent.classList.remove("gct-d-none");
				document.documentElement.classList.add("no-scroll");
			}
		})
	}

	const input = document.getElementById("product-search");
	const inputMobile = document.getElementById("product-search-mobile");
	const inputMobileMenu = document.getElementById("product-search-mobile-menu");

	let abortController: AbortController | null = null;

	async function onChange(event: Event, mobile: boolean, menu: boolean = false) {

		const searchValue = (event.target as HTMLInputElement).value;
		const searchResult = document.getElementById(mobile ? menu ? "search-results-mobile-menu" : "search-results-mobile" : "search-results");

		if (searchResult) searchResult.innerHTML = menu ? '<div class="spinner-wrapper gct-pt-20 gct-pb-20 menu-spinner-wrapper"><div class="spinner"/></div>' : '<div class="spinner-wrapper gct-pt-20 gct-pb-20"><div class="spinner"/></div>';

		const endpoint = (event.target as HTMLInputElement).dataset.endpoint;

		if (abortController) {
			abortController.abort()
		}

		if (searchValue === "") {
			if (searchResult) searchResult.innerHTML = "<div></div>";
			return;
		}

		abortController = new AbortController();
		const signal = abortController.signal;

		try {
			const response = await fetch(`${endpoint}?s=${searchValue}&post_type=product`, { signal });

			if (!response.ok) {
				noticeFailure("There was an unexpected error.");
				return;
			}

			const html = await response.text();

			const res = new DOMParser().parseFromString(html, "text/html").getElementsByName("product-content-tile");

			if (res.length) {
				const result = <div className="gct-flex-column gct-gap-16 gct-pt-40 test">
					<div className="gct-flex-row gct-flex-space-between">
						<div class="gct-h5">Products</div>
						{/* <a href={`${endpoint}?s=${searchValue}&post_type=product`} className="gct-underline-offset">View All</a> */}
						<a href={`${endpoint}?s=${searchValue}&post_type=product`} className="gct-underline-offset gct-h5">View All</a>
					</div>
				</div>;

				const productPreview = <div className="gct-product-archive-loop"></div>
				const numOfProdcuts = 4;/* mobile ? 2 : 4; */
				const previewArray = Array.from(res).slice(0, numOfProdcuts);

				previewArray.forEach(el => {
					el.setAttribute("name", "product-content-tile-header");
					productPreview.append(el);
				})

				result.append(productPreview);

				/* result.append(<a href={`${endpoint}?s=${searchValue}&post_type=product`} className="gct-underline-offset gct-w100 gct-flex-row gct-flex-center gct-text-lg gct-mt-40">View All Results</a>); */

				if (searchResult) searchResult.innerHTML = result.outerHTML;
			} else {
				const result = menu ? `<div class="gct-pt-40 menu-spinner-wrapper">No result found for "${searchValue}". Please try another search.</div>` : `<div class="gct-pt-40">No result found for "${searchValue}". Please try another search.</div>`;

				if (searchResult) searchResult.innerHTML = result;
			}
		} catch (error) {
			if ((error as Error).name !== 'AbortError') noticeFailure("There was an unexpected error.");
		}
	}

	input?.addEventListener("input", (event) => onChange(event, false));
	inputMobile?.addEventListener("input", (event) => onChange(event, true));
	inputMobileMenu?.addEventListener("input", (event) => onChange(event, true, true));

	const clearButton = document.getElementById("clear-search");
	const clearButtonMobile = document.getElementById("clear-search-mobile");
	const clearButtonMobileMenu = document.getElementById("clear-search-mobile-menu");

	async function onClickDesktop() {
		const searchResult = document.getElementById("search-results");
		if (input) (input as HTMLInputElement).value = "";
		if (searchResult) searchResult.innerHTML = "";
	}

	async function onClickMobile() {
		const searchResultMobile = document.getElementById("search-results-mobile");
		if (inputMobile) (inputMobile as HTMLInputElement).value = "";
		if (searchResultMobile) searchResultMobile.innerHTML = "";
	}

	async function onClickMobileMenu() {
		const searchResultMobileMenu = document.getElementById("search-results-mobile-menu");
		if (inputMobileMenu) (inputMobileMenu as HTMLInputElement).value = "";
		if (searchResultMobileMenu) searchResultMobileMenu.innerHTML = "";
	}

	clearButton?.addEventListener('click', onClickDesktop);
	clearButtonMobile?.addEventListener("click", onClickMobile)
	clearButtonMobileMenu?.addEventListener("click", onClickMobileMenu);
}
